import { Offer, ProductCardType, ProductItemType } from "./productCardTypes";

export const convertProductCard = (
  productItem: ProductCardType,
  offer?: Offer | null
): ProductItemType => {
  return {
    id: productItem.id,
    adult: productItem.adult,
    attributeName: productItem.options[0]?.name,
    averageRating: productItem.ratingsSummary.averageRating,
    brand: productItem.brand,
    clubCatchEligible: offer?.clubFreeShipping,
    clubCatchExclusive: offer?.clubExclusive,
    freeShippingAvailable: offer?.freeShipping,
    imageLocation: productItem.assets.hero.url,
    isPersonalisedProduct: productItem.options.length > 0,
    offerId: offer?.id,
    ratingCount: productItem.ratingsSummary.numberOfRatings,
    sellable: productItem.sellable,
    sellerId: offer?.seller.id,
    title: productItem.title,
    url: `/product/${productItem.slug}`,
    priceTag: productItem.priceTag,
    badges: offer?.badges,
    sellPrice: offer?.sellPrice?.amount,
  };
};
